(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Ritorno dalla scheda prodotto.
     L'originale cercava la card al solo DOMContentLoaded: con l'infinite scroll
     la card della pagina 2 o 3 non esiste ancora e l'utente ripartiva dall'alto.
     Qui la si attende per un tempo limitato, poi si lascia perdere. */
  (function () {
    const hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    const id = decodeURIComponent(hash.slice(1));
    const jump = (card) => {
      card.scrollIntoView({ behavior: 'instant', block: 'center' });
      card.setAttribute('data-returned', 'true');
    };

    const start = () => {
      const now = document.getElementById(id);
      if (now) return jump(now);

      const observer = new MutationObserver(() => {
        const card = document.getElementById(id);
        if (card) { observer.disconnect(); jump(card); }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 4000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
